import Analytics from 'analytics';
import { getThirdPartyTrackingManagerApiClient } from 'lib/SplashApiClient/subclients/ThirdPartyTrackingManagerApiClient';
import Logger from 'observability/Logger';
import getTrackerPlugins from './getTrackerPlugins';
import filterRestrictedTrackers from './filterRestrictedTrackers';

const LOG = new Logger('ThirdPartyTrackingManager');

class ThirdPartyTrackingManager {
    async init({ eventId }) {
        const thirdPartyTrackingManagerApiClient = getThirdPartyTrackingManagerApiClient(eventId);
        // Perform request to get plugins
        this.trackerList = await thirdPartyTrackingManagerApiClient.getTrackerList();
        return this;
    }

    async getAnalyticsInstance({ app, debug, version, cookieConsentedCategories }) {
        this.plugins = await this.getPlugins({ cookieConsentedCategories });
        const getAnalytics = this.initializeGetAnalytics({ app, debug, version });

        if (debug) {
            LOG.debug('ThirdPartyTrackingManager - getAnalytics ✅', getAnalytics);
            LOG.debug('ThirdPartyTrackingManager - plugins ✅', this.plugins);
        }

        return getAnalytics;
    }

    /**
     * Performs the GET request to get the tracking data for this event from the backend
     * then converts that list into an array of plugins for Analytics
     * @async
     * @param {Object} options - The options object
     * @param {Array<string>} options.cookieConsentedCategories - Array of consented cookie categories
     * @returns {Array} - analytics plugins
     */
    async getPlugins({ cookieConsentedCategories }) {
        const allowedTrackersList = filterRestrictedTrackers({
            trackerList: this.trackerList,
            cookieConsentedCategories,
        });
        const plugins = await getTrackerPlugins({ trackerList: allowedTrackersList });

        return plugins;
    }

    /**
     * Initializes the Third Party Tracking Manager analytics library
     *
     * @param {Object} options - the initialization options
     * @param {string} options.app - the app identifier
     * @param {boolean} options.debug - if we are in debug mode
     * @param {string} options.version - the version
     *
     * @returns {Object} - the Analytics implementation
     */
    initializeGetAnalytics({ app, debug, version }) {
        const analytics = Analytics({
            app,
            debug,
            version,
            plugins: this.plugins,
        });

        return analytics;
    }
}

export default new ThirdPartyTrackingManager();
